/// <amd-module name="Test/Analytics/TestResultsGridCommon/Types" />
import * as CommonTypes from "Test/Analytics/Common/Types";

export interface IDetailedTestListSource {
    queryDetailedList(
        testResultContext: CommonTypes.ITestReportContext,
        confValues: CommonTypes.IReportConfiguration,
        orderByColumn: CommonTypes.IDetailedListColumn,
        nextPageToken: CommonTypes.INextDataPageToken | null | undefined,
        groupValue: number | string
    ): Promise<CommonTypes.IDetailedListData>;
    queryGroupedDetailedList(
        testResultContext: CommonTypes.ITestReportContext,
        confValues: CommonTypes.IReportConfiguration,
        orderByColumn: CommonTypes.IDetailedListColumn,
        nextPageToken: CommonTypes.INextDataPageToken | undefined | null
    ): Promise<CommonTypes.IDetailedListData>;
}
